import { Drawer, List } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { routes } from '../../common/utils/routes';
import { selectSidebarOpen } from '../../services/controllers/common/CommonSelector';
import { toggleSidebar } from '../../services/controllers/common/CommonSlice';
import NavbarItem from './SidebarNavItem';

const SidebarNav: React.FC = () => {
  const dispatch = useDispatch();

  const open = useSelector(selectSidebarOpen);

  const options = [
    { label: 'Tất cả công thức', path: routes.DEFAULT },
    { label: 'Thêm công thức', path: routes.ADD_FORMULA, bottomDivider: true },
    { label: 'Hoạt động sản xuất', path: routes.FORMULA_ACTIVITY },
    { label: 'Quản ký kho', path: routes.WAREHOUSE },
  ];

  const toggle = () => {
    dispatch(toggleSidebar());
  };

  return (
    <Drawer anchor="left" open={open} onClose={toggle}>
      <List sx={{ width: 300 }}>
        {options.map((item) => (
          <NavbarItem key={item.label} item={item} toggle={toggle} />
        ))}
      </List>
    </Drawer>
  );
};

export default SidebarNav;
